import { useLoaderData } from '@remix-run/react'
import type { loader } from '../index.tsx'
import type { SerializeFrom } from '@remix-run/node'
import ProductCard from '#app/routes/_marketing+/($location)+/products+/components/product-card.tsx'

type LoaderData = SerializeFrom<typeof loader>

export default function RelatedProducts() {
	const { relatedProducts } = useLoaderData<LoaderData>()

	return (
		<>
			{relatedProducts.length > 0 && (
				<div className="mt-40 flex flex-col">
					<h3 className="mb-2 p-2 text-2xl font-bold leading-none tracking-tight text-zinc-800">
						Related Products
					</h3>
					<div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
						{relatedProducts.map((product) => (
							<ProductCard key={product.internalId} product={product} />
						))}
					</div>
				</div>
			)}
		</>
	)
}
